// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListTab-module__font-s-10___x0Cwe {
  font-size: 10px !important;
}

.ListTab-module__font-s-12___LoXRQ {
  font-size: 12px !important;
}

.ListTab-module__font-s-13___SdI4i {
  font-size: 13px !important;
}

.ListTab-module__font-s-14___Xut2v {
  font-size: 14px !important;
}

.ListTab-module__font-s-15___pPxHH {
  font-size: 15px !important;
}

.ListTab-module__font-s-16___dUDtH {
  font-size: 16px !important;
}

.ListTab-module__font-s-18___qZ9UJ {
  font-size: 18px !important;
}

.ListTab-module__font-s-20___zNSLh {
  font-size: 20px !important;
}

.ListTab-module__font-s-22___r1xd6 {
  font-size: 22px !important;
}

.ListTab-module__font-s-28___nP_v6 {
  font-size: 28px !important;
}

.ListTab-module__font-w-400___xQSel {
  font-weight: 400 !important;
}

.ListTab-module__font-w-500___Qw3bq {
  font-weight: 500 !important;
}

.ListTab-module__font-w-600___QRg8u {
  font-weight: 600 !important;
}

.ListTab-module__font-w-700___sB8o4 {
  font-weight: 700 !important;
}

.ListTab-module__p-5___xSg6V {
  padding: 5px !important;
}

.ListTab-module__p-12___AS55K {
  padding: 12px !important;
}

.ListTab-module__p-16___yK7kf {
  padding: 16px !important;
}

.ListTab-module__p-30___jWWlx {
  padding: 30px !important;
}

.ListTab-module__p-b-0___EuKYn {
  padding-bottom: 0 !important;
}

.ListTab-module__p-b-5___iDg9C {
  padding-bottom: 5px !important;
}

.ListTab-module__p-b-10___nqL0n {
  padding-bottom: 10px !important;
}

.ListTab-module__p-b-12____uSfA {
  padding-bottom: 12px !important;
}

.ListTab-module__p-b-16___bmSmG {
  padding-bottom: 16px !important;
}

.ListTab-module__p-b-18___rRnD8 {
  padding-bottom: 18px !important;
}

.ListTab-module__p-b-20___fNwFI {
  padding-bottom: 20px !important;
}

.ListTab-module__p-b-25____5dOi {
  padding-bottom: 25px !important;
}

.ListTab-module__p-b-30___AbRh5 {
  padding-bottom: 30px !important;
}

.ListTab-module__p-b-50___qrSo3 {
  padding-bottom: 50px !important;
}

.ListTab-module__p-t-0___GzNZT {
  padding-top: 0 !important;
}

.ListTab-module__p-t-12___MmrI6 {
  padding-top: 12px !important;
}

.ListTab-module__p-t-16___YwGZA {
  padding-top: 16px !important;
}

.ListTab-module__p-t-18___Wqo8N {
  padding-top: 18px !important;
}

.ListTab-module__p-t-20___tHdNB {
  padding-top: 20px !important;
}

.ListTab-module__p-t-30___X8xnI {
  padding-top: 30px !important;
}

.ListTab-module__p-t-40___Ln2wH {
  padding-top: 40px !important;
}

.ListTab-module__p-t-50___HH1s3 {
  padding-top: 50px !important;
}

.ListTab-module__p-l-20___OnbDQ {
  padding-left: 20px !important;
}

.ListTab-module__p-l-30____2JYj {
  padding-left: 30px !important;
}

.ListTab-module__p-l-40___ROxfl {
  padding-left: 40px !important;
}

.ListTab-module__p-r-16___tXLqR {
  padding-right: 16px !important;
}

.ListTab-module__p-r-20___hUHbK {
  padding-right: 20px !important;
}

.ListTab-module__p-r-30___GZpxn {
  padding-right: 30px !important;
}

.ListTab-module__p-r-50___lAfPu {
  padding-right: 50px !important;
}

.ListTab-module__p-r-60___h0U16 {
  padding-right: 60px !important;
}

.ListTab-module__m-b-1___YMxsb {
  margin-bottom: 1px !important;
}

.ListTab-module__m-b-2___GPpgu {
  margin-bottom: 2px !important;
}

.ListTab-module__m-b-6___mRfMR {
  margin-bottom: 6px !important;
}

.ListTab-module__m-b-8___vciph {
  margin-bottom: 8px !important;
}

.ListTab-module__m-b-10___MpTej {
  margin-bottom: 10px !important;
}

.ListTab-module__m-b-14___KDAlz {
  margin-bottom: 14px !important;
}

.ListTab-module__m-b-16___FAplf {
  margin-bottom: 16px !important;
}

.ListTab-module__m-b-20___LOW0j {
  margin-bottom: 20px !important;
}

.ListTab-module__m-b-22____fCFb {
  margin-bottom: 22px !important;
}

.ListTab-module__m-b-24___CnFGK {
  margin-bottom: 24px !important;
}

.ListTab-module__m-b-30___muGi4 {
  margin-bottom: 30px !important;
}

.ListTab-module__m-b-32___GDdKC {
  margin-bottom: 32px !important;
}

.ListTab-module__m-b-40___LHrbB {
  margin-bottom: 40px !important;
}

.ListTab-module__m-t-2___Qaz83 {
  margin-top: 2px !important;
}

.ListTab-module__m-t-3___L_z5a {
  margin-top: 3px !important;
}

.ListTab-module__m-t-4___WPtV3 {
  margin-top: 4px !important;
}

.ListTab-module__m-t-5___nUAvh {
  margin-top: 5px !important;
}

.ListTab-module__m-t-8___e6rJ8 {
  margin-top: 8px !important;
}

.ListTab-module__m-t-10____a_ub {
  margin-top: 10px !important;
}

.ListTab-module__m-t-15___y92wp {
  margin-top: 15px !important;
}

.ListTab-module__m-t-16___zZTw7 {
  margin-top: 16px !important;
}

.ListTab-module__m-t-20___bSiNe {
  margin-top: 20px !important;
}

.ListTab-module__m-t-22___NPOVo {
  margin-top: 22px !important;
}

.ListTab-module__m-t-30___vWP9x {
  margin-top: 30px !important;
}

.ListTab-module__m-t-32___O8bor {
  margin-top: 32px !important;
}

.ListTab-module__m-l-auto____cUGH {
  margin-left: auto !important;
}

.ListTab-module__m-l-4___vwxnA {
  margin-left: 4px !important;
}

.ListTab-module__m-l-5___Mgr13 {
  margin-left: 5px !important;
}

.ListTab-module__m-l-6___X2w45 {
  margin-left: 6px !important;
}

.ListTab-module__m-l-8___D5i11 {
  margin-left: 8px !important;
}

.ListTab-module__m-l-10___cLNia {
  margin-left: 10px !important;
}

.ListTab-module__m-l-16___x4wkS {
  margin-left: 16px !important;
}

.ListTab-module__m-l-20___GobcJ {
  margin-left: 20px !important;
}

.ListTab-module__m-l-24___xTpzP {
  margin-left: 24px !important;
}

.ListTab-module__m-l-30___Q4b2f {
  margin-left: 30px !important;
}

.ListTab-module__m-l-35___I0ti_ {
  margin-left: 35px !important;
}

.ListTab-module__m-l-40___VJAv0 {
  margin-left: 40px !important;
}

.ListTab-module__m-r-8___kqXSR {
  margin-right: 8px !important;
}

.ListTab-module__m-r-10___QFDZv {
  margin-right: 10px !important;
}

.ListTab-module__m-r-16___s_EP1 {
  margin-right: 16px !important;
}

.ListTab-module__m-r-20___MsLgq {
  margin-right: 20px !important;
}

.ListTab-module__m-r-24___M3aVE {
  margin-right: 24px !important;
}

.ListTab-module__m-r-30___FCWKN {
  margin-right: 30px !important;
}

.ListTab-module__m-r-40___Vgg5E {
  margin-right: 40px !important;
}

.ListTab-module__border-r-3___FR1um {
  border-radius: 3px !important;
}

.ListTab-module__border-r-4___Gy9cW {
  border-radius: 4px !important;
}

.ListTab-module__border-r-6___PhVDz {
  border-radius: 6px !important;
}

.ListTab-module__border-r-10___BHtH4 {
  border-radius: 10px !important;
}

.ListTab-module__border-r-12___YLVTw {
  border-radius: 12px !important;
}

.ListTab-module__border-r-16___Vrg0X {
  border-radius: 16px !important;
}

.ListTab-module__border-r-50___J2wwk {
  border-radius: 50% !important;
}

.ListTab-module__primary-border___dxIIU {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.ListTab-module__primary-border-b___OudY2 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.ListTab-module__primary-border-t___n55Ku {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.ListTab-module__primary-border-l___wUbdR {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.ListTab-module__primary-border-r___TB1ry {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.ListTab-module__secondary-border___kxYmJ {
  border: 1px solid #637768;
}

.ListTab-module__secondary-border-b___VV1cn {
  border-bottom: 1px solid #637768;
}

.ListTab-module__secondary-border-t___ATtmr {
  border-top: 1px solid #637768;
}

.ListTab-module__secondary-border-l___iqJAi {
  border-left: 1px solid #637768;
}

.ListTab-module__secondary-border-r___SJ08X {
  border-right: 1px solid #637768;
}

.ListTab-module__gap-0___TBLs2 {
  gap: 0 !important;
}

.ListTab-module__gap-2___UI2DD {
  gap: 2px !important;
}

.ListTab-module__gap-4___ghr0W {
  gap: 4px !important;
}

.ListTab-module__gap-5___ovhCI {
  gap: 5px !important;
}

.ListTab-module__gap-6___ZajkL {
  gap: 6px !important;
}

.ListTab-module__gap-8___oHNxz {
  gap: 8px !important;
}

.ListTab-module__gap-10___jQPbP {
  gap: 10px !important;
}

.ListTab-module__gap-12___kiYrq {
  gap: 12px !important;
}

.ListTab-module__gap-14___CKtxU {
  gap: 14px !important;
}

.ListTab-module__gap-16___V7SP_ {
  gap: 16px !important;
}

.ListTab-module__gap-18___zKgeg {
  gap: 18px !important;
}

.ListTab-module__gap-20___bL3tG {
  gap: 20px !important;
}

.ListTab-module__gap-24____PIuc {
  gap: 24px !important;
}

.ListTab-module__gap-26___TEjnh {
  gap: 26px !important;
}

.ListTab-module__gap-30___t2oBc {
  gap: 30px !important;
}

.ListTab-module__gap-32___n1M16 {
  gap: 32px !important;
}

.ListTab-module__gap-40___ckf2d {
  gap: 40px !important;
}

.ListTab-module__gap-50___tlpAx {
  gap: 50px !important;
}

.ListTab-module__flex-1___jTsvr {
  flex: 1;
}

.ListTab-module__flex-none___MmLEb {
  flex: none !important;
}

.ListTab-module__flex-column___vidqP {
  display: flex;
  flex-direction: column !important;
}

.ListTab-module__flex-row___cYog_ {
  display: flex;
  flex-direction: row !important;
}

.ListTab-module__vertically-centered___NoFLG {
  display: flex;
  align-items: center !important;
}

.ListTab-module__horizontally-centered___FSCi7 {
  display: flex;
  justify-content: center !important;
}

.ListTab-module__horizontally-end___ZCVel {
  display: flex;
  justify-content: end !important;
}

.ListTab-module__vertically-start___hicAL {
  display: flex;
  align-items: start !important;
}

.ListTab-module__space-between___Z1GAj {
  display: flex;
  justify-content: space-between !important;
}

.ListTab-module__flex-wrap___AJnXS {
  flex-wrap: wrap !important;
}

.ListTab-module__height-100___qHkXo {
  height: 100%;
}

.ListTab-module__width-50___iW5Ag {
  width: 50% !important;
}

.ListTab-module__width-100___qCUk2 {
  width: 100%;
}

.ListTab-module__cursor-pointer___AQzMt {
  cursor: pointer;
}

.ListTab-module__cursor-not-allowed___Gkd__ {
  cursor: not-allowed !important;
}

.ListTab-module__absolute-centered___FO0ii {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.ListTab-module__absolute___m3Vpt {
  position: absolute;
}

.ListTab-module__relative___fh7Ly {
  position: relative;
}

.ListTab-module__fixed___BTm2R {
  position: fixed;
}

.ListTab-module__visible___nxzW2 {
  opacity: 1;
}

.ListTab-module__invisible___a6PTZ {
  opacity: 0;
}

.ListTab-module__col-90___i98Z8 {
  width: 90% !important;
}

.ListTab-module__col-auto___IiWnB {
  width: auto !important;
}

.ListTab-module__medical-tabs___GSFkl {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.ListTab-module__medical-table-new___AGF0H {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ListTab-module__medical-table-new___AGF0H:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ListTab-module__medical-table-new___AGF0H::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ListTab-module__medical-table-new___AGF0H::-webkit-scrollbar-track {
  display: none;
}
.ListTab-module__medical-table-new___AGF0H.ListTab-module__no-pagination___H1BjD {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ListTab-module__medical-table-new___AGF0H.ListTab-module__no-pagination___H1BjD:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ListTab-module__medical-table-new___AGF0H.ListTab-module__no-pagination___H1BjD::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ListTab-module__medical-table-new___AGF0H.ListTab-module__no-pagination___H1BjD::-webkit-scrollbar-track {
  display: none;
}

.ListTab-module__medical-table-empty___nTNyx {
  padding: 14px 40px !important;
}

.ListTab-module__icon-btn___YV_R1 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.ListTab-module__search-icon___SdPYx {
  width: 24px;
  height: 24px;
  align-self: center;
}

.ListTab-module__disable-select___V9IDd {
  user-select: none;
}

.ListTab-module__break-word____0P6o {
  word-break: break-word;
}

.ListTab-module__popup-clear-btn___kgEbo {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.ListTab-module__scroll-m-b-20___TJxQc {
  scroll-margin-bottom: 20px;
}

.ListTab-module__table___kRujk {
  width: 100%;
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - 230px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.ListTab-module__table___kRujk:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ListTab-module__table___kRujk::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ListTab-module__table___kRujk::-webkit-scrollbar-track {
  display: none;
}
.ListTab-module__table___kRujk .ListTab-module__empty___MM3iY {
  padding: 14px 40px;
}
.ListTab-module__table___kRujk .ListTab-module__viewButton___YJRba {
  font-family: var(--font-family);
  font-weight: 400;
  color: #375844;
  text-decoration-line: underline;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Labs/tabs/ListTab/ListTab.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,WAAA;ECOA,kJDLE;ECMF,kBAAA;EACA,kBAAA;ADwpBF;ACtpBE;EACE,oCAAA;EACA,mBAAA;ADwpBJ;ACrpBE;EACE,UAAA;EACA,6BAAA;ADupBJ;ACppBE;EACE,aAAA;ADspBJ;AAnqBE;EACE,kBAAA;AAqqBJ;AAlqBE;EEUA,+BApBO;EAqBP,gBAFmD;EFPjD,cAAA;EACA,+BAAA;AAqqBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.table {\n  width: 100%;\n  @include verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(\n          --patient-details-footer\n        ) - 230px\n    )\n  );\n\n  .empty {\n    padding: 14px 40px;\n  }\n\n  .viewButton {\n    @include get-font($roboto);\n    color: get-color(greenNew, dark);\n    text-decoration-line: underline;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `ListTab-module__font-s-10___x0Cwe`,
	"fontS12": `ListTab-module__font-s-12___LoXRQ`,
	"fontS13": `ListTab-module__font-s-13___SdI4i`,
	"fontS14": `ListTab-module__font-s-14___Xut2v`,
	"fontS15": `ListTab-module__font-s-15___pPxHH`,
	"fontS16": `ListTab-module__font-s-16___dUDtH`,
	"fontS18": `ListTab-module__font-s-18___qZ9UJ`,
	"fontS20": `ListTab-module__font-s-20___zNSLh`,
	"fontS22": `ListTab-module__font-s-22___r1xd6`,
	"fontS28": `ListTab-module__font-s-28___nP_v6`,
	"fontW400": `ListTab-module__font-w-400___xQSel`,
	"fontW500": `ListTab-module__font-w-500___Qw3bq`,
	"fontW600": `ListTab-module__font-w-600___QRg8u`,
	"fontW700": `ListTab-module__font-w-700___sB8o4`,
	"p5": `ListTab-module__p-5___xSg6V`,
	"p12": `ListTab-module__p-12___AS55K`,
	"p16": `ListTab-module__p-16___yK7kf`,
	"p30": `ListTab-module__p-30___jWWlx`,
	"pB0": `ListTab-module__p-b-0___EuKYn`,
	"pB5": `ListTab-module__p-b-5___iDg9C`,
	"pB10": `ListTab-module__p-b-10___nqL0n`,
	"pB12": `ListTab-module__p-b-12____uSfA`,
	"pB16": `ListTab-module__p-b-16___bmSmG`,
	"pB18": `ListTab-module__p-b-18___rRnD8`,
	"pB20": `ListTab-module__p-b-20___fNwFI`,
	"pB25": `ListTab-module__p-b-25____5dOi`,
	"pB30": `ListTab-module__p-b-30___AbRh5`,
	"pB50": `ListTab-module__p-b-50___qrSo3`,
	"pT0": `ListTab-module__p-t-0___GzNZT`,
	"pT12": `ListTab-module__p-t-12___MmrI6`,
	"pT16": `ListTab-module__p-t-16___YwGZA`,
	"pT18": `ListTab-module__p-t-18___Wqo8N`,
	"pT20": `ListTab-module__p-t-20___tHdNB`,
	"pT30": `ListTab-module__p-t-30___X8xnI`,
	"pT40": `ListTab-module__p-t-40___Ln2wH`,
	"pT50": `ListTab-module__p-t-50___HH1s3`,
	"pL20": `ListTab-module__p-l-20___OnbDQ`,
	"pL30": `ListTab-module__p-l-30____2JYj`,
	"pL40": `ListTab-module__p-l-40___ROxfl`,
	"pR16": `ListTab-module__p-r-16___tXLqR`,
	"pR20": `ListTab-module__p-r-20___hUHbK`,
	"pR30": `ListTab-module__p-r-30___GZpxn`,
	"pR50": `ListTab-module__p-r-50___lAfPu`,
	"pR60": `ListTab-module__p-r-60___h0U16`,
	"mB1": `ListTab-module__m-b-1___YMxsb`,
	"mB2": `ListTab-module__m-b-2___GPpgu`,
	"mB6": `ListTab-module__m-b-6___mRfMR`,
	"mB8": `ListTab-module__m-b-8___vciph`,
	"mB10": `ListTab-module__m-b-10___MpTej`,
	"mB14": `ListTab-module__m-b-14___KDAlz`,
	"mB16": `ListTab-module__m-b-16___FAplf`,
	"mB20": `ListTab-module__m-b-20___LOW0j`,
	"mB22": `ListTab-module__m-b-22____fCFb`,
	"mB24": `ListTab-module__m-b-24___CnFGK`,
	"mB30": `ListTab-module__m-b-30___muGi4`,
	"mB32": `ListTab-module__m-b-32___GDdKC`,
	"mB40": `ListTab-module__m-b-40___LHrbB`,
	"mT2": `ListTab-module__m-t-2___Qaz83`,
	"mT3": `ListTab-module__m-t-3___L_z5a`,
	"mT4": `ListTab-module__m-t-4___WPtV3`,
	"mT5": `ListTab-module__m-t-5___nUAvh`,
	"mT8": `ListTab-module__m-t-8___e6rJ8`,
	"mT10": `ListTab-module__m-t-10____a_ub`,
	"mT15": `ListTab-module__m-t-15___y92wp`,
	"mT16": `ListTab-module__m-t-16___zZTw7`,
	"mT20": `ListTab-module__m-t-20___bSiNe`,
	"mT22": `ListTab-module__m-t-22___NPOVo`,
	"mT30": `ListTab-module__m-t-30___vWP9x`,
	"mT32": `ListTab-module__m-t-32___O8bor`,
	"mLAuto": `ListTab-module__m-l-auto____cUGH`,
	"mL4": `ListTab-module__m-l-4___vwxnA`,
	"mL5": `ListTab-module__m-l-5___Mgr13`,
	"mL6": `ListTab-module__m-l-6___X2w45`,
	"mL8": `ListTab-module__m-l-8___D5i11`,
	"mL10": `ListTab-module__m-l-10___cLNia`,
	"mL16": `ListTab-module__m-l-16___x4wkS`,
	"mL20": `ListTab-module__m-l-20___GobcJ`,
	"mL24": `ListTab-module__m-l-24___xTpzP`,
	"mL30": `ListTab-module__m-l-30___Q4b2f`,
	"mL35": `ListTab-module__m-l-35___I0ti_`,
	"mL40": `ListTab-module__m-l-40___VJAv0`,
	"mR8": `ListTab-module__m-r-8___kqXSR`,
	"mR10": `ListTab-module__m-r-10___QFDZv`,
	"mR16": `ListTab-module__m-r-16___s_EP1`,
	"mR20": `ListTab-module__m-r-20___MsLgq`,
	"mR24": `ListTab-module__m-r-24___M3aVE`,
	"mR30": `ListTab-module__m-r-30___FCWKN`,
	"mR40": `ListTab-module__m-r-40___Vgg5E`,
	"borderR3": `ListTab-module__border-r-3___FR1um`,
	"borderR4": `ListTab-module__border-r-4___Gy9cW`,
	"borderR6": `ListTab-module__border-r-6___PhVDz`,
	"borderR10": `ListTab-module__border-r-10___BHtH4`,
	"borderR12": `ListTab-module__border-r-12___YLVTw`,
	"borderR16": `ListTab-module__border-r-16___Vrg0X`,
	"borderR50": `ListTab-module__border-r-50___J2wwk`,
	"primaryBorder": `ListTab-module__primary-border___dxIIU`,
	"primaryBorderB": `ListTab-module__primary-border-b___OudY2`,
	"primaryBorderT": `ListTab-module__primary-border-t___n55Ku`,
	"primaryBorderL": `ListTab-module__primary-border-l___wUbdR`,
	"primaryBorderR": `ListTab-module__primary-border-r___TB1ry`,
	"secondaryBorder": `ListTab-module__secondary-border___kxYmJ`,
	"secondaryBorderB": `ListTab-module__secondary-border-b___VV1cn`,
	"secondaryBorderT": `ListTab-module__secondary-border-t___ATtmr`,
	"secondaryBorderL": `ListTab-module__secondary-border-l___iqJAi`,
	"secondaryBorderR": `ListTab-module__secondary-border-r___SJ08X`,
	"gap0": `ListTab-module__gap-0___TBLs2`,
	"gap2": `ListTab-module__gap-2___UI2DD`,
	"gap4": `ListTab-module__gap-4___ghr0W`,
	"gap5": `ListTab-module__gap-5___ovhCI`,
	"gap6": `ListTab-module__gap-6___ZajkL`,
	"gap8": `ListTab-module__gap-8___oHNxz`,
	"gap10": `ListTab-module__gap-10___jQPbP`,
	"gap12": `ListTab-module__gap-12___kiYrq`,
	"gap14": `ListTab-module__gap-14___CKtxU`,
	"gap16": `ListTab-module__gap-16___V7SP_`,
	"gap18": `ListTab-module__gap-18___zKgeg`,
	"gap20": `ListTab-module__gap-20___bL3tG`,
	"gap24": `ListTab-module__gap-24____PIuc`,
	"gap26": `ListTab-module__gap-26___TEjnh`,
	"gap30": `ListTab-module__gap-30___t2oBc`,
	"gap32": `ListTab-module__gap-32___n1M16`,
	"gap40": `ListTab-module__gap-40___ckf2d`,
	"gap50": `ListTab-module__gap-50___tlpAx`,
	"flex1": `ListTab-module__flex-1___jTsvr`,
	"flexNone": `ListTab-module__flex-none___MmLEb`,
	"flexColumn": `ListTab-module__flex-column___vidqP`,
	"flexRow": `ListTab-module__flex-row___cYog_`,
	"verticallyCentered": `ListTab-module__vertically-centered___NoFLG`,
	"horizontallyCentered": `ListTab-module__horizontally-centered___FSCi7`,
	"horizontallyEnd": `ListTab-module__horizontally-end___ZCVel`,
	"verticallyStart": `ListTab-module__vertically-start___hicAL`,
	"spaceBetween": `ListTab-module__space-between___Z1GAj`,
	"flexWrap": `ListTab-module__flex-wrap___AJnXS`,
	"height100": `ListTab-module__height-100___qHkXo`,
	"width50": `ListTab-module__width-50___iW5Ag`,
	"width100": `ListTab-module__width-100___qCUk2`,
	"cursorPointer": `ListTab-module__cursor-pointer___AQzMt`,
	"cursorNotAllowed": `ListTab-module__cursor-not-allowed___Gkd__`,
	"absoluteCentered": `ListTab-module__absolute-centered___FO0ii`,
	"absolute": `ListTab-module__absolute___m3Vpt`,
	"relative": `ListTab-module__relative___fh7Ly`,
	"fixed": `ListTab-module__fixed___BTm2R`,
	"visible": `ListTab-module__visible___nxzW2`,
	"invisible": `ListTab-module__invisible___a6PTZ`,
	"col90": `ListTab-module__col-90___i98Z8`,
	"colAuto": `ListTab-module__col-auto___IiWnB`,
	"medicalTabs": `ListTab-module__medical-tabs___GSFkl`,
	"medicalTableNew": `ListTab-module__medical-table-new___AGF0H`,
	"noPagination": `ListTab-module__no-pagination___H1BjD`,
	"medicalTableEmpty": `ListTab-module__medical-table-empty___nTNyx`,
	"iconBtn": `ListTab-module__icon-btn___YV_R1`,
	"searchIcon": `ListTab-module__search-icon___SdPYx`,
	"disableSelect": `ListTab-module__disable-select___V9IDd`,
	"breakWord": `ListTab-module__break-word____0P6o`,
	"popupClearBtn": `ListTab-module__popup-clear-btn___kgEbo`,
	"scrollMB20": `ListTab-module__scroll-m-b-20___TJxQc`,
	"table": `ListTab-module__table___kRujk`,
	"empty": `ListTab-module__empty___MM3iY`,
	"viewButton": `ListTab-module__viewButton___YJRba`
};
module.exports = ___CSS_LOADER_EXPORT___;
